import { render } from "./ChangelogHome.vue?vue&type=template&id=21b3c0e0&scoped=true&ts=true&lang=pug"
import script from "./ChangelogHome.vue?vue&type=script&lang=ts"
export * from "./ChangelogHome.vue?vue&type=script&lang=ts"

import "./ChangelogHome.vue?vue&type=style&index=0&id=21b3c0e0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b3c0e0"]])

export default __exports__